// Generado desde design-system/components/core/Spinner.tsx — no editar; edita el .ts/.tsx y corre build-ds.
import { cn } from '../../lib/cn';
/** Spinner indeterminado. Para progreso real usar Progress (con aria-valuenow). */
export function Spinner({ size = 18, className, label }) {
    return (<svg width={size} height={size} viewBox="0 0 24 24" className={cn('animate-spin motion-reduce:animate-none', className)} role={label ? 'status' : undefined} aria-label={label} aria-hidden={label ? undefined : 'true'}>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeOpacity=".22" strokeWidth="2.5"/>
      <path d="M21 12a9 9 0 0 0-9-9" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
    </svg>);
}
